import { render } from "./OrthoDash.vue?vue&type=template&id=3133364e&scoped=true"
import script from "./OrthoDash.vue?vue&type=script&lang=js"
export * from "./OrthoDash.vue?vue&type=script&lang=js"

import "./OrthoDash.vue?vue&type=style&index=0&id=3133364e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3133364e"]])

export default __exports__